(function () {
    'use strict';

    function main() {
        var searchPage = wo$('[data-search-page]');
        if (!searchPage.length) return;

        var searchController = {
            init: function () {
                WhistleOut.getAds('Broadband');
                WhistleOut.bindCitiesAutoComplete(searchPage);
            }
        };

        searchController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
